import React, { PureComponent } from 'react'
import {connect} from "react-redux";

import * as actions from '../../store/actions/actions'

import FloatingButton from '../../components/button/floatingButton'
import Modal from 'react-bootstrap/Modal'

import {Button, Card, CardHeader, Container, Row, UncontrolledTooltip} from "reactstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Header from "../../components/Headers/Header";
import * as Roles from "../../store/actions/roles"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import './corporate.css'

import italianCorporateTranslations from "../../translations/corporate/corporate/it.corporate.json";
import englishCorporateTranslations from "../../translations/corporate/corporate/en.corporate.json";
import {OPERATION_DISABLE, OPERATION_EDIT, OPERATION_VIEW} from "../../store/actions/roles";

class Corporate extends PureComponent {
  state = {
    deleteShow: false,
    enableDisableShow: false,
    corporate: {
      enabled: false,
      corporateSenderName: ''
    }
  }

  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianCorporateTranslations, "it");
    this.props.addTranslationForLanguage(englishCorporateTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchCorporates()
  }

  onCreateClick = () => {
    this.props.createCorporatePage()
  }

  onDetailClick = (corporate,bankId) => {
    let corporateDetail={
      corporate:corporate,
      bankId:bankId
    }
    this.props.fetchCorporateDetail(corporateDetail)
  }

  onEditClick = (corporate,bankId) => {
    this.props.fetchCorporateEdit(corporate,bankId)
  }

  handleEnableDisableteShow = (corporate) => {
    this.setState({
      enableDisableShow: true,
      corporate: corporate
    })
  }

  handleEnableDisableClose = () => {
    this.setState({
      enableDisableShow: false,
      corporate: {
        enabled: false,
        corporateSenderName: ''
      }
    })
  }

  onEnableOrDisableClick = () => {
    if(this.state.corporate.enabled === false)
      this.props.enableCorporateEdit(this.state.corporate)
    else if(this.state.corporate.enabled === true)
      this.props.disableCorporateEdit(this.state.corporate)
    this.handleEnableDisableClose()
  }

  handleDeleteShow = (corporate) => {
    this.setState({
      deleteShow: true,
      corporate: corporate
    })
  }

  handleDeleteClose = () => {
    this.setState({
      deleteShow: false
    })
  }

  onDeleteClick = () => {
    this.props.deleteCorporate(this.state.corporate)
    this.handleDeleteClose()
  }

  checkBankCorporateAdminCorporateAccess=(userCorporates,row,opType,op)=>{

    let currentCorporateSenderId=row.corporateSenderId;

    let access=Roles.checkCorporateAccess(userCorporates,currentCorporateSenderId,opType)

    if(access===true){
      if(op===OPERATION_DISABLE){
        return <Button size="sm" onClick={()=>this.handleEnableDisableteShow(row)}>
          {row.enabled === true ? <i className="fas fa-power-off text-danger" /> : <i className="fas fa-power-off text-success" />}
        </Button>
      }else if(op === OPERATION_EDIT){
        return <Button size="sm" onClick={()=>this.onEditClick(row.id,row.bank)}>
          <i className="ni ni-ui-04 text-yellow" />
        </Button>
      }else if(op === OPERATION_VIEW){
        return <Button size="sm" onClick={()=>this.onDetailClick(row.id,row.bank)}>
          <i className="ni ni-zoom-split-in text-primary" />
        </Button>
      }

    }else{
      return ""
    }
  }

  render() {
    let deleteModal = <Modal show={this.state.deleteShow} onHide={this.handleDeleteClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <Translate id="corporate.modal.delete.title" data={{ corporateSenderName: this.state.corporate != null ? this.state.corporate.corporateSenderName : "" }}/>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Translate id="corporate.modal.delete.body" data={{ corporateSenderName: this.state.corporate != null ? this.state.corporate.corporateSenderName : "" }}/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleDeleteClose}>
          <Translate id="corporate.close"/>
        </Button>
        <Button variant="primary" onClick={this.onDeleteClick}>
          <Translate id="corporate.delete"/>
        </Button>
      </Modal.Footer>
    </Modal>

    let enableDisableModal = <Modal show={this.state.enableDisableShow} onHide={this.handleEnableDisableClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {this.state.corporate.enabled === false ?
            <Translate id="corporate.modal.enable.title" data={{ corporateSenderName: this.state.corporate != null ? this.state.corporate.corporateSenderName : "" }}/> :
            <Translate id="corporate.modal.disable.title" data={{ corporateSenderName: this.state.corporate != null ? this.state.corporate.corporateSenderName : "" }}/>
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.state.corporate.enabled === false ?
          <Translate id="corporate.modal.enable.body" data={{ corporateSenderName: this.state.corporate != null ? this.state.corporate.corporateSenderName : "" }}/> :
          <Translate id="corporate.modal.disable.body" data={{ corporateSenderName: this.state.corporate != null ? this.state.corporate.corporateSenderName : "" }}/>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleEnableDisableClose}>
          <Translate id="corporate.close"/>
        </Button>
        <Button variant="primary" onClick={this.onEnableOrDisableClick}>
          {this.state.corporate.enabled === false ?
            <Translate id="corporate.enable.button"/> :
            <Translate id="corporate.disable.button"/>
          }
        </Button>
      </Modal.Footer>
    </Modal>

    let role = this.props.role
    let userCorporates=this.props.userCorporates;
    let enableDisableButton = ""
    let editButton = ""
    if (Roles.checkRole(role,Roles.MODULE_CORPORATE, Roles.OPERATION_EDIT, true)) {
      editButton = {
        text: <Translate id="corporate.edit"/>, headerClasses: 'button-header-col',
        formatter: (cellContent, row) => (
            role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminCorporateAccess(userCorporates, row, Roles.OPERATION_TYPE_WRITE, Roles.OPERATION_EDIT)
                :
                <Button size="sm" onClick={() => this.onEditClick(row.id, row.bank)}>
                  <i className="ni ni-ui-04 text-yellow"/>
                </Button>

        )
      }

    }

    if(Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_EDIT, true)){
      enableDisableButton = {
        text: <Translate id="corporate.enable.disable"/>,headerClasses:'button-header-col',
        formatter: (cellContent, row) => (
            role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminCorporateAccess(userCorporates,row,Roles.OPERATION_TYPE_WRITE,Roles.OPERATION_DISABLE)
                :
          <Button size="sm" onClick={()=>this.handleEnableDisableteShow(row)}>
            {row.enabled === true ? <i className="fas fa-power-off text-danger" /> : <i className="fas fa-power-off text-success" />}
          </Button>
        )
      }
    }

    let tooltip = ''
    let createButton = ""
    if(Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_CREATE, true)){
      if (role === 'BANK_CORPORATE_ADMIN' || role === 'BANK_ADMIN' || role === 'PAYDO_ADMIN' || role === 'PAYDO_MANAGER') {
        tooltip = <UncontrolledTooltip delay={0} placement="left" target="creationButton">
          Funzionalità temporaneamente disabilitata. Nel caso di necessità, chiedere supporto al team PayDo al seguente indirizzo e-mail
          <br />
          <a href="mailto:supporto_clienti@plick.eu">supporto_clienti@plick.eu</a>
        </UncontrolledTooltip>
        createButton = <span id="creationButton">
            <FloatingButton disabled="true" label="Create user" onClick={this.onCreateClick} color="primary"/>
          </span>
      } else {
        createButton =
            <FloatingButton disabled="false" label="Create user" onClick={this.onCreateClick} color="primary"/>
      }
    }

    const columns = [
      { dataField: 'corporateSenderId', text: <Translate id="corporate.id"/>,
        sort: true,
        sortCaret: (order, column) => {
          if (!order)
            return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
          else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
          else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
          return null;
        }
      },
      { dataField: 'corporateSenderName', text: <Translate id="corporate.name"/>,
        sort: true,
        sortCaret: (order, column) => {
          if (!order)
            return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
          else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
          else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
          return null;
        }
      },
      { dataField: 'enabled', text: <Translate id="corporate.enabled"/>,headerClasses:'button-header-col',
        formatter: (cellContent, row) => (
          <div className="disabled">
            <input type="checkbox" checked={ row.enabled } disabled />
          </div>
        )
      },
      { text: <Translate id="corporate.detail"/>,headerClasses:'button-header-col',
        formatter:(cellContent, row) => (
            role === Roles.BANK_CORPORATE_ADMIN ? this.checkBankCorporateAdminCorporateAccess(userCorporates,row,Roles.OPERATION_TYPE_READ,Roles.OPERATION_VIEW)
                :
            <Button size="sm" onClick={()=>this.onDetailClick(row.id,row.bank)}>
              <i className="ni ni-zoom-split-in text-primary" />
            </Button>
        )
      },
      editButton,
      enableDisableButton
    ]
    const rowEvents = {
      scope:"row"
    };
    let table = this.props.corporates === null ? null :
        <BootstrapTable bootstrap4 headerClasses="thead-light" classes="align-items-center table-flush" keyField='corporateSenderId' data={ this.props.corporates }
                        columns={ columns } pagination={ paginationFactory() } rowEvents={ rowEvents }
        />
    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">Corporates</h3>
                      </div>
                      <div className="col">
                        <div style={{float:'right'}}>
                          {createButton}
                          {tooltip}
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  {table}
                  {deleteModal}
                  {enableDisableModal}
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    corporates: state.corporate.corporates,
    userCorporates: state.authentication.authenticatedUser.userCorporates,
    role : state.authentication.authenticatedUser.role
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
    fetchCorporateDetail: (corporate) => dispatch({ type: actions.FETCH_CORPORATE_DETAIL_REQUEST, value: corporate }),
    fetchCorporateEdit: (corporate,bankId) => dispatch({ type: actions.FETCH_CORPORATE_EDIT_REQUEST, value: {corporate:corporate,bankId:bankId} }),
    disableCorporateEdit: (corporate) => dispatch({ type: actions.DISABLE_CORPORATE_REQUEST, value: corporate }),
    enableCorporateEdit: (corporate) => dispatch({ type: actions.ENABLE_CORPORATE_REQUEST, value: corporate }),
    createCorporatePage: () => dispatch({ type: actions.CORPORATE_CREATE_PAGE_REQUEST }),
    deleteCorporate: (corporate) => dispatch({ type: actions.DELETE_CORPORATE_REQUEST, value: corporate })
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Corporate));